const API_BASE = process.env.REACT_APP_API_URL || 'https://api.grandindigoembroidery.com';

const headers = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

const IMAGE_BASE = 'https://admin.grandindigoembroidery.com/public/storage';

/**
 * Build the full image URL for a blog image path.
 * @param {string|null} imagePath
 * @returns {string}
 */
export const getBlogImageUrl = (imagePath) => {
  if (!imagePath) return '/images/service1.png'; // fallback
  if (imagePath.startsWith('http')) return imagePath;
  return `${IMAGE_BASE}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
};

/**
 * Fetch all active blogs (paginated).
 * @param {number} page
 * @param {number} perPage
 * @returns {Promise<{ data: Blog[], meta: object }>}
 */
export const getBlogs = async (page = 1, perPage = 9) => {
  const res = await fetch(
    `${API_BASE}/blogs?page=${page}&per_page=${perPage}`,
    { method: 'GET', headers: headers() }
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to fetch blogs.');
  return data;
};

/**
 * Fetch a single blog by slug.
 * @param {string} slug
 * @returns {Promise<Blog>}
 */
export const getBlogBySlug = async (slug) => {
  const res = await fetch(
    `${API_BASE}/blogs/${slug}`,
    { method: 'GET', headers: headers() }
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Blog not found.');
  return data.blog ?? data;
};